import {initConfig} from '@gaotu/open-app-sdk';
import useUa, {AppName} from '@/hooks/useUa';

const {outOpenParams} = useUa();
export const configMap: {
  [key: string]: {
    scheme: string;
    packageName: string;
    universalHost: string;
    fallback?: string;
    appstore?: string;
  };
} = {
  gaotu: {
    scheme: 'superclass',
    packageName: 'com.gaotu100.superclass',
    universalHost: 'www.gaotu.cn/jump',
  },
  gongkao: {
    scheme: 'supergongkao',
    packageName: 'com.gaotu100.gongkao',
    universalHost: 'www.gaotu.cn/jump/6',
  },
  tutu: {
    scheme: 'supertutu',
    packageName: 'com.gaotu100.tutu',
    universalHost: 'www.gaotu100.com/jump',
  },
  jingpin: {
    scheme: 'superjingpin',
    packageName: 'com.gaotu100.jingpin',
    // 精品(高中)没有pc官网跳不了app
    universalHost: '',
    fallback: 'https://m.gtgz.cn/account/download',
    appstore: 'https://m.gtgz.cn/account/download',
  },
  xinli: {
    scheme: 'superxinli',
    packageName: 'com.gaotu100.xinli',
    universalHost: 'www.gaotu.cn/jump/3',
    fallback: 'https://m.gaotu.cn/account/download?p_client=3',
    appstore: 'https://m.gaotu.cn/account/download?p_client=3',
  },
  ketang: {
    scheme: 'superketang',
    packageName: 'com.gaotu100.ketang',
    universalHost: 'www.naiyouxuexi.com/jump',
  },
};

export const initOpenAppSDK = () => {
  const {app} = outOpenParams;
  if (!app) {// 不是端外打开直接返回
    return;
  }
  const {scheme, packageName, universalHost, fallback, appstore} = configMap[app as AppName] || configMap.gaotu;
  // const mProxyUrl = process.env.NODE_ENV === 'production' ? 'https://m.gaotu.cn' : 'https://test-m.gaotu.cn';
  const downloadUrl = `http://a.app.qq.com/o/simple.jsp?pkgname=${packageName}&ios_scheme=${scheme}%3A%2F%2Fjump%3Fcategory%3Dnative%26action_type%3Dlogin%3A%2F%2Fopen`;

  initConfig({// 初始化 open-app-sdk
    scheme,
    packageName,
    universalHost,
    appid: app === 'gaotu' ? 'wx6755c78557f70009' : '', // 目前高途 App 才有微信开放标签
    // ios唤起app失败跳转地址
    appstore: appstore || downloadUrl,
    // 安卓唤起app失败跳转地址
    fallback: fallback || downloadUrl,
    timeout: 3000, // 超时时间, 3000 内页面未隐藏认为唤起失败, 安卓会跳转上面 fallback 链接, ios 会跳转 appstore 链接
    wechatFailPathname: ''
  });
};
